import React from 'react';
import CursorTooltip from '../../Components/CursorTooltip/';
import Marker from '../../Components/Marker/';
import block from 'bem-cn-lite';
import { I18n } from 'react-i18next';

class ImageArea extends React.Component {
    clickHandler = (event) => {
        const markerPosition = this.getCursorPosition(event);
        const {isDisabled, onClick} = this.props;

        if (isDisabled) {
            return false;
        }

        onClick(markerPosition);
    }

    getCursorPosition(event) {
        const {x, y} = this.getImageAreaPosition();

        return {
            x: event.nativeEvent.clientX - x,
            y: event.nativeEvent.clientY - y,
        };
    }

    getImageAreaPosition() {
        const rect = this.imageArea.getBoundingClientRect();

        return {
            x: rect.left,
            y: rect.top
        };
    }

    mouseMoveHandler = (event) => {
        const {isDisabled, isCommenting} = this.props;

        if (isDisabled || isCommenting) {
            return false;
        }

        const cursorPosition = this.getCursorPosition(event);
        this.showCursorTooltip(cursorPosition);
    }

    mouseLeaveHandler = () => {
        if (this.cursorTooltip) {
            this.cursorTooltip.style.visibility = 'hidden';
        }
    }

    showCursorTooltip({x, y}) {
        if (this.cursorTooltip) {
            this.cursorTooltip.style.top = `${y}px`;
            this.cursorTooltip.style.left = `${x}px`;
            this.cursorTooltip.style.visibility = 'visible';
        }
    }

    render() {
        const b = block('ImageArea');

        const {isCommenting, markerPosition, isDisabled} = this.props;
        const cursorStyle = {cursor: isDisabled ? 'default' : 'crosshair'};

        return (
            <I18n>
            {
                (t) => (
                    <div
                        className={b()}
                        ref={(ref) => this.imageArea = ref}
                        onClick={this.clickHandler}
                        onMouseMove={this.mouseMoveHandler}
                        onMouseLeave={this.mouseLeaveHandler}
                        style={cursorStyle}>


                        {markerPosition && <Marker position={markerPosition} />}

                        {
                            !isCommenting &&
                            <CursorTooltip
                                cursorTooltipRef={(ref) => this.cursorTooltip = ref}
                                tooltipTextKey='click'/>
                        }

                        {
                            !markerPosition &&
                            <div className={b('tooltips-wrap')}>
                                <div className={b('main-tooltip')}>
                                    {t('imageProofing:tooltip')}
                                </div>
                                <div className="blink"></div>
                            </div>
                        }
                    </div>
                )
            }
            </I18n>
            
        )
    }
}

export default ImageArea;